import { CARD_LABELS, type LessonDraft } from "../../shared/schema";
import { FuriganaText } from "./FuriganaText";

export function PhonePreview({ draft, index }: { draft?: LessonDraft; index: number }) {
  const card = draft?.cards[index];
  return <aside className="preview-panel" aria-label="手機預覽">
    <div className="phone">
      <div className="phone__status">9:41 <span>●●●</span></div>
      <div className="phone__body">
        <div className="phone__top"><span>←</span><strong>{draft?.title.zhTw || "Lesson"}</strong></div>
        <div className="phone__progress"><span style={{ width: draft ? `${((index + 1) / Math.max(draft.cards.length, 1)) * 100}%` : "0%" }} /></div>
        {card ? <div className="study-card">
          <small>{CARD_LABELS[card.type]}</small>
          <h2>{card.title}</h2>
          {card.content.japanese && <p className="japanese"><FuriganaText segments={card.content.japanese} /></p>}
          {card.content.prompt && <p className="prompt">{card.content.prompt}</p>}
          {card.content.dialogueTurns?.map((turn, i) => <div className="dialogue" key={i}><b>{turn.speaker}</b><FuriganaText segments={turn.japanese} /></div>)}
          {card.content.choices?.map((choice) => <div className="choice" key={choice}>{choice}</div>)}
          {card.content.meaningZhTw && <p className="meaning">{card.content.meaningZhTw}</p>}
          {card.content.explanationZhTw && <p className="explanation">{card.content.explanationZhTw}</p>}
        </div> : <div className="preview-empty">選擇或新增卡片</div>}
        <div className="phone__actions"><button>返回</button><button className="primary">繼續</button></div>
      </div>
    </div>
  </aside>;
}
